export enum FinanceCompanies_Enum {
  GECapital = 1,
  GECustom = 2,
  Welcome = 3,
  AUF = 4,
  BCT = 6,
  GreenLight = 7,
  AdvantageFinance = 8,
  Moneybarn = 9,
  PC = 10,
  WCF = 11,
  BlackHorse = 12,
  MarshFinance = 13,
  FirstResponse = 15,
  MotoNovoFinance = 16,
  ACF = 18,
  MallardFinance = 19,
  Santander = 20,
  CloseMotorFinance = 21,
  Moneyway = 22,
  FortisLease = 23,
  CentralTrust = 24,
  HeywoodFinance = 25,
  AautoUnionFinance = 26,
  JigsawFinance = 27,
  CreationFinance = 28,
  BillingFinance = 29,
  FirstStopCarFinance = 30,
  BarclaysPartnerFinance = 31,
  AlpheraFinancialServices = 32,
  SouthernFinance = 33,
  HitachiCapital = 34,
  Laser = 35,
  TheCarFinanceCompany = 36,
  Glenside = 37,
  ParagonFinance = 38,
  StartlineFinance = 39,
  AmigoFinance = 40,
  GeorgeBanco = 41,
  FirstStopPersonalLoan = 42,
  FirstStopSecuredLoan = 43,
  Ratesetter = 44,
  GloFinance = 45,
  MoneywayPrime = 46,
  LendingWorks = 47,
  BlueMotorFinance = 48,
  Carfinance247 = 49,
  Alphera = 50,
  Zopa = 51,
  AvantCredit = 52,
  FundingCorp = 53,
  ParagonFinance2 = 54,
  ProgressiveMoney = 55,
  PredictedNearPrime = 56,
  Cf247Money = 57,
  Oodle = 58,
  HampshireTrustBank = 59,
  PCFBank = 60,
  UnitedTrustBank = 61,
  MannIsland = 62,
  BNPParibas = 63
}
